import { Link } from "react-router-dom";
import { Vault } from "lucide-react";
import { vaultToken } from "@/lib/api";

export const Header = ({ count, onUnlock }) => {
  const hasAccess = !!vaultToken();
  return (
    <header className="fixed top-0 inset-x-0 z-40 backdrop-blur-xl bg-[#07090E]/75 border-b border-white/5" data-testid="site-header">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2" data-testid="header-logo-link">
          <span className="h-8 w-8 rounded-lg bg-emerald-500 grid place-items-center text-[#07090E]"><Vault size={18} /></span>
          <span className="font-display font-bold text-lg">Bonus<span className="text-emerald-400">Vault</span></span>
        </Link>
        <div className="flex items-center gap-3">
          {count != null && (
            <span className="hidden sm:flex items-center gap-2 text-xs font-mono text-slate-400" data-testid="header-live-count">
              <span className="h-2 w-2 rounded-full bg-emerald-400 live-dot" /> {count} LIVE OFFERS
            </span>
          )}
          {hasAccess ? (
            <Link to="/vault" data-testid="header-open-vault-link" className="rounded-full bg-emerald-500 hover:bg-emerald-400 text-[#07090E] text-sm font-bold px-4 py-2 transition-colors">Open Vault</Link>
          ) : (
            <button onClick={onUnlock} data-testid="header-unlock-button" className="rounded-full bg-emerald-500 hover:bg-emerald-400 text-[#07090E] text-sm font-bold px-4 py-2 transition-colors">Unlock for $3</button>
          )}
        </div>
      </div>
    </header>
  );
};
